import React from 'react'
import PropTypes from 'prop-types'
import { Header, Individual, Company } from '.'

const buildPhone = (phone, type) => {
  if (!phone) {
    return { areaCode: '', number: '', type }
  }

  const numberPattern = /\d+/g
  const onlyNumbers = phone.match(numberPattern).join([])
  return {
    areaCode: onlyNumbers.substr(0, 2),
    number: onlyNumbers.substr(2),
    type
  }
}

const ProfileInfos = props => {
  if (props.step === 0) {
    const Component = props.participant.isCompany ? Company : Individual
    return (
      <div className='col-12' data-index='1'>
        <Header
          step={props.step}
          handleStepChange={props.handleStepChange}
          description={'Documento: ' + props.customer.documentNumber}
          active
        />
        <Component {...props} buildPhone={buildPhone} />
      </div>
    )
  }

  return (
    <div className='col-12' data-index='1'>
      <Header
        step={props.step}
        handleStepChange={props.handleStepChange}
        description={'Documento: ' + props.customer.documentNumber}
      />
    </div>
  )
}

ProfileInfos.propTypes = {
  step: PropTypes.number.isRequired,
  handleStepChange: PropTypes.func.isRequired,
  participant: PropTypes.object.isRequired,
  customer: PropTypes.object,
  forceFocus: PropTypes.func.isRequired
}

export default ProfileInfos



// WEBPACK FOOTER //
// ./src/features/Checkout/ProfileInfos/ProfileInfos.js